export default "__VITE_ASSET__9d54b642__"